import Api from '../../path';
import { fetchData } from '@umu/umu-fetch'; 
import { SwitchNum } from '@umu/umu-types';
 
export interface IProximaRank {
    ranking: number;
    all_rank_num: string;
    total_points: string;
    avatar: string;
    name: string;
    show_user_level: number;
    student_id: string;
    user_level: number;
    umu_id: string;
    is_self: SwitchNum;
}

export const getAroundPointsRank = (courseId: string): Promise<IResponse<IProximaRank[]>> => {
	return fetchData(Api.AROUND_RANK, {group_id: courseId}).then((res: IResponse<IProximaRank[]>) => {
		return res;
	});
};
